/**
 * Created by Languagenut on 25/01/2019.
 */



import React  from 'react';
import './payment.css';
import {Button , Row , Col } from "react-bootstrap";
import LicenceService from '../../services/licence-service.js';

export default class DirectDebitPayment extends React.Component {

    constructor(props) {
        super();
        this.props = props;
        this.state = {
        }
    }

    onClick(){
        LicenceService.goCardlessPayment(this.props.packageData , this.props.userData)
    }

    render(){
        return <div>
            <br/>
            <div class='card-wrapper'></div>
            <br/>
            <form >
                <Row>
                    <Col md={12}><Button onClick={this.onClick.bind(this)} block>Go to Gocardless</Button></Col>
                </Row>
            </form>
            <br/>
        </div>
    }
}